<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [self]="breadcrumbSelf"
      [parents]="breadcrumbParents">
    </app-breadcrumb>
  </div>
  <div class="breadcrumb-menu d-flex">
    <!--CREATE-->
    <div
      *ngIf="rightModel.projectCreate.hasRight()"
      class="breadcrumb-button-icon-container cursor-pointer negative-margin-right"
      uiSref="Admin.ProjectCreate">
      <a class="btn-setting d-flex align-items-center" title="{{'COMMON_ADD' | translate}}">
        <i class="icomoon icomoon-add"></i>
        <span class="breadcrumb-button-text-visible">{{'COMMON_ADD' | translate}}</span>
      </a>
    </div>
  </div>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding animated fadeIn">

  <div class="card">

    <div class="card-header">
      {{'MENU_NAVBAR_PROJECTS' | translate}}

      <div class="card-actions">
        <a class="btn-setting cursor-pointer" (click)="toggleSearch()" title="{{'COMMON_BUTTON_SEARCH' | translate}}"><i
          class="icomoon icomoon-search"></i></a>
      </div><!-- /.card-actions -->
    </div>

    <div class="card-body border-bottom" *ngIf="showSearch" appHighlightContainer>
      <div class="row form-group">

        <div class="col">
          <label class="search-label">{{'COMMON_TABLE_HEADER_ID' | translate}}</label>
          <input type="text" class="form-control"
                 placeholder="{{'COMMON_TABLE_HEADER_ID' | translate}}"
                 maxlength="{{UiConstants.maxInputLongLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.id">
        </div>

        <div class="col">
          <label class="search-label">{{'COMMON_NAME' | translate}}</label>
          <input type="text" class="form-control"
                 placeholder="{{'COMMON_NAME' | translate}}"
                 maxlength="{{UiConstants.maxInputLongLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.name">
        </div>

        <div class="col">
          <label class="search-label">{{'COMMON_EXTERNAL_ID' | translate}}</label>
          <input type="text" class="form-control"
                 placeholder="{{'COMMON_EXTERNAL_ID' | translate}}"
                 maxlength="{{UiConstants.maxInputLongLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.externalId">
        </div>

        <div class="col">
          <label class="search-label">{{'ROLE_SEARCH_FIELD_DISABLED' | translate}}</label>
          <select class="form-control"
                  [compareWith]="SelectUtils.compareObjects"
                  [(ngModel)]="searchModel.disabled">
            <option *ngFor="let item of disabledItems" [ngValue]="item" >{{item.text}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-md-end align-items-end">
        <div class="btn-group" role="group">
          <button type="button" (click)="onSearchReset()" class="btn btn-outline-primary search-button mr-1">
            {{'COMMON_BUTTON_SEARCH_DELETE' | translate}}
          </button>
          <button type="button" (click)="onSearchClicked()" class="btn btn-primary search-button">
            {{'COMMON_BUTTON_SEARCH' | translate}}
          </button>
        </div>
      </div>
    </div><!-- /.card-body-->
    <div class="card-body">
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="table-sorter-header fit">
            <app-table-field-sorter [orderField]="Project.OrderField.ID"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-md-down">
            <app-table-field-sorter [orderField]="Project.OrderField.EXPLICIT_ORDER_NUMBER"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.EXPLICIT_ORDER_NUMBER)"
                                    (orderChange)="orderBy($event)" [text]="'TASK_TABLE_HEADER_ORDER' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="Project.OrderField.NAME"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_NAME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-lg-down">
            <app-table-field-sorter [orderField]="Project.OrderField.CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.CREATION_TIME)"
                                    (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-md-down">
            <app-table-field-sorter  [orderField]="Project.OrderField.UPDATE_TIME"
                                     [orderType]="queryModel.getOrderType(Project.OrderField.UPDATE_TIME)"
                                     (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_UPDATE_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-options-menu">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let project of list | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }" [disabledTableRow]="project.disabled">
          <td class="fit align-middle">{{project.id}}</td>
          <td class="fit align-middle">{{project.explicitOrderNumber}}</td>
          <td class="responsive-table-column long">
            <div class="d-flex justify-content-start align-items-center">
              <app-type-icon [icon]="project.icon" class="mr-05"></app-type-icon>
              <div>
                <a *ngIf="rightModel.projectUpdate.hasRight()"
                   class="id-text cursor-pointer"
                   href="#" onclick="return false"
                   uiSref="Admin.ProjectEdit"
                   [uiParams]="{ id: project.id }"
                   title="{{'COMMON_BUTTON_EDIT' | translate}}">
                  {{project.name}}
                </a>
                <span *ngIf="!rightModel.projectUpdate.hasRight()">{{project.name}}</span>
                <div class="table-text-subtitle">
                  {{project.externalId}}
                </div>
              </div>
            </div>
          </td>
          <td class="fit hidden-lg-down align-middle">
            {{project.creationTime.toUtcIsoString() | date:'short'}}
          </td>
          <td class="fit hidden-md-down align-middle">
            {{project.updateTime.toUtcIsoString() | date:'short'}}
          </td>
          <td class="align-middle">
            <app-table-options-menu>
              <app-dropdown-item
                [iconClass]="'icomoon-detail'"
                [titleStringKey]="'COMMON_BUTTON_DETAILS'"
                class="cursor-pointer"
                uiSref="Admin.ProjectDetail"
                [uiParams]="{ id: project.id }">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="rightModel.deliveryMethodUpdate.hasRight()"
                [iconClass]="'icomoon-modify'"
                [titleStringKey]="'COMMON_BUTTON_EDIT'"
                class="cursor-pointer"
                uiSref="Admin.ProjectEdit"
                [uiParams]="{ id: project.id }">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="!project.disabled && rightModel.projectDisable.hasRight()"
                [iconClass]="'icomoon-disable icomoon-disable-table'"
                [titleStringKey]="'COMMON_BUTTON_DISABLE'"
                class="cursor-pointer"
                href="#" onclick="return false"
                (click)="setDisabled(project.id, true)">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="project.disabled && rightModel.projectDisable.hasRight()"
                [iconClass]="'icomoon-enable icomoon-enable-table'"
                [titleStringKey]="'COMMON_BUTTON_ENABLE'"
                class="cursor-pointer"
                href="#" onclick="return false"
                (click)="setDisabled(project.id, false)">
              </app-dropdown-item>
            </app-table-options-menu>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="table-sorter-header fit">
            <app-table-field-sorter [orderField]="Project.OrderField.ID"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-md-down">
            <app-table-field-sorter [orderField]="Project.OrderField.EXPLICIT_ORDER_NUMBER"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.EXPLICIT_ORDER_NUMBER)"
                                    (orderChange)="orderBy($event)" [text]="'TASK_TABLE_HEADER_ORDER' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="Project.OrderField.NAME"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.NAME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_NAME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-lg-down">
            <app-table-field-sorter [orderField]="Project.OrderField.CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(Project.OrderField.CREATION_TIME)"
                                    (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header fit hidden-md-down">
            <app-table-field-sorter  [orderField]="Project.OrderField.UPDATE_TIME"
                                     [orderType]="queryModel.getOrderType(Project.OrderField.UPDATE_TIME)"
                                     (orderChange)="orderBy($event)" [text]="'COMMON_TABLE_HEADER_UPDATE_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-options-menu">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </tfoot>
      </table>
      <app-table-paging
        [currentNumberOfItems]="queryModel.currentNumberOfItems"
        [totalNumberOfItems]="queryModel.totalNumberOfItems"
        [itemsPerPage]="queryModel.itemsPerPage"
        (pageChange)="pageChanged($event)"
        (itemsPerPageChange)="itemsPerPageChanged($event)">
      </app-table-paging>
    </div>
  </div>
</div>
